module.exports = __webpack_public_path__ + "static/media/golf10.23376b89.jpg";